import moment from 'moment';
import { DATE_FORMAT } from '../../constants';

const WaitTime = ({ sinceTimestamp, withSuffix, ...rest }) => {
  return <span {...rest}>{moment(sinceTimestamp, DATE_FORMAT).fromNow(!withSuffix)}</span>;
};

export default WaitTime;
